import React from 'react'
import BentoboxGrid from '../bentobox-grid'

const TypeTwoInside = (props) => <BentoboxGrid {...props} inside={true} featured={true} />

export default TypeTwoInside
